package com.appsyde.shared.modules.account.domain.model

data class BillingStatus(
    val billingStatus: String,
    val hasBillingAccess: Boolean,
    val trialEndsAt: String?,
    val daysRemainingTrial: Int?,
    val billingPlan: String?
)
